export type AttachmentSource = "file" | "paste" | "oekaki"

const ATTACHMENT_SOURCE_SYMBOL = Symbol.for("nijiurachan.attachment-source")

/** upfile部品のtool名を投稿時の添付経路へ変換する。oekaki98ははっちゃんキャンバス。 */
export function attachmentSourceForTool(tool: string): AttachmentSource {
  if (tool === "paste") {
    return "paste"
  }
  return tool === "oekaki" || tool === "oekaki98" ? "oekaki" : "file"
}

/** 同一プロセス内だけで使う添付Fileの生成来歴を非列挙で付与する。 */
export function markAttachmentSource<T extends object>(
  file: T,
  source: AttachmentSource,
): T {
  Object.defineProperty(file, ATTACHMENT_SOURCE_SYMBOL, {
    configurable: false,
    enumerable: false,
    value: source,
    writable: false,
  })
  return file
}

/** 明示タグが無いFileは、名前に関係なく通常ファイルとして扱う。 */
export function getAttachmentSource(file: object): AttachmentSource {
  const source = Reflect.get(file, ATTACHMENT_SOURCE_SYMBOL)
  return source === "paste" || source === "oekaki" ? source : "file"
}
